import { render, staticRenderFns } from "./CardItemChipsContainer.vue?vue&type=template&id=380a79dc"
import script from "./CardItemChipsContainer.vue?vue&type=script&lang=ts"
export * from "./CardItemChipsContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380a79dc')) {
      api.createRecord('380a79dc', component.options)
    } else {
      api.reload('380a79dc', component.options)
    }
    module.hot.accept("./CardItemChipsContainer.vue?vue&type=template&id=380a79dc", function () {
      api.rerender('380a79dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardItemChipsContainer.vue"
export default component.exports